var map = {
	"./Avator1.png": 73121,
	"./Avator10.png": 1976,
	"./Avator11.png": 7919,
	"./Avator12.png": 52437,
	"./Avator13.png": 88306,
	"./Avator14.png": 96234,
	"./Avator15.png": 66111,
	"./Avator16.png": 51672,
	"./Avator17.png": 31166,
	"./Avator18.png": 96192,
	"./Avator19.png": 80031,
	"./Avator2.png": 64494,
	"./Avator20.png": 12946,
	"./Avator3.png": 63651,
	"./Avator4.png": 34164,
	"./Avator5.png": 8946,
	"./Avator6.png": 83820,
	"./Avator7.png": 57188,
	"./Avator8.png": 58175,
	"./Avator9.png": 16740
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22689;